import { CookiesENUSTranslations } from 'src/components/Cookies/translations/en-us';
import { CookiesPTBRTranslations } from 'src/components/Cookies/translations/pt-br';
import { FormENUSTranslations } from 'src/components/Form/translations/en-us';
import { FormPTBRTranslations } from 'src/components/Form/translations/pt-br';
import { LanguageMenuENUSTranslations } from 'src/components/LanguageMenu/translations/en-us';
import { LanguageMenuPTBRTranslations } from 'src/components/LanguageMenu/translations/pt-br';
import { FooterENUSTranslations } from 'src/components/Layout/Footer/translations/en-us';
import { FooterPTBRTranslations } from 'src/components/Layout/Footer/translations/pt-br';
import { HeaderENUSTranslations } from 'src/components/Layout/Header/translations/en-us';
import { HeaderPTBRTranslations } from 'src/components/Layout/Header/translations/pt-br';
import { MobileMenuENUSTranslations } from 'src/components/MobileMenu/translations/en-us';
import { MobileMenuPTBRTranslations } from 'src/components/MobileMenu/translations/pt-br';
import { ContactSalesPageENUSTranslations } from 'src/pages/ContactSales/translations/en-us';
import { ContactSalesPagePTBRTranslations } from 'src/pages/ContactSales/translations/pt-br';
import { FreemiumSignUpENUSTranslations } from 'src/pages/Freemium/SignUp/translations/en-us';
import { FreemiumSignUpPTBRTranslations } from 'src/pages/Freemium/SignUp/translations/pt-br';
import { FreemiumUpgradeENUSTranslations } from 'src/pages/Freemium/Upgrade/translations/en-us';
import { FreemiumUpgradePTBRTranslations } from 'src/pages/Freemium/Upgrade/translations/pt-br';
import { LandingPageCarouselTabENUSTranslations } from 'src/pages/Landing/components/CarouselTab/translations/en-us';
import { LandingPageCarouselTabPTBRTranslations } from 'src/pages/Landing/components/CarouselTab/translations/pt-br';
import { LandingPageENUSTranslations } from 'src/pages/Landing/translations/en-us';
import { LandingPagePTBRTranslations } from 'src/pages/Landing/translations/pt-br';
import { NotFoundPageENUSTranslations } from 'src/pages/NotFound/translations/en-us';
import { NotFoundPagePTBRTranslations } from 'src/pages/NotFound/translations/pt-br';

import {
  CommonTextsENUSTranslations,
  CommonTextsPTBRTranslations,
} from './translations/common';

export const enUSTranslations = {
  ...FooterENUSTranslations,
  ...HeaderENUSTranslations,
  ...LandingPageENUSTranslations,
  ...NotFoundPageENUSTranslations,
  ...ContactSalesPageENUSTranslations,
  ...LanguageMenuENUSTranslations,
  ...CookiesENUSTranslations,
  ...LandingPageCarouselTabENUSTranslations,
  ...MobileMenuENUSTranslations,
  ...CommonTextsENUSTranslations,
  ...FreemiumUpgradeENUSTranslations,
  ...FormENUSTranslations,
  ...FreemiumSignUpENUSTranslations,
};

export const ptBRTranslations = {
  ...FooterPTBRTranslations,
  ...HeaderPTBRTranslations,
  ...LandingPagePTBRTranslations,
  ...NotFoundPagePTBRTranslations,
  ...ContactSalesPagePTBRTranslations,
  ...LanguageMenuPTBRTranslations,
  ...CookiesPTBRTranslations,
  ...LandingPageCarouselTabPTBRTranslations,
  ...MobileMenuPTBRTranslations,
  ...CommonTextsPTBRTranslations,
  ...FreemiumUpgradePTBRTranslations,
  ...FormPTBRTranslations,
  ...FreemiumSignUpPTBRTranslations,
};

export const resources: { [language: string]: any } = {
  'en-US': {
    name: 'English',
    translation: enUSTranslations,
  },
  'pt-BR': {
    name: 'Portuguese - Brazil',
    translation: ptBRTranslations,
  },
};
